import React from 'react';
import { Cell, Row } from 'react-table';

import { getEstimatedLossLabel } from '@trqk/utils';

import { summarizeRowsAbove } from '../../constants';

interface WorkEstimatedLossCellProps {
    cell: Cell<TrqkGapChannel, NumberRange>;
    row: Row<TrqkGapChannelAudio>;
}

/**
 * For summary rows, this component returns null.
 * For non-summary rows, this component renders a range of estimated loss values, like: `$1 to $5K`.
 * @param props - {@link WorkEstimatedLossCellProps}
 */
export function WorkEstimatedLossCell({
    cell,
    row,
}: WorkEstimatedLossCellProps): JSX.Element | null {
    if (row.subRows.length > summarizeRowsAbove) {
        return null;
    }

    const max = cell?.value?.max ?? 0;
    const min = cell?.value?.min ?? 0;

    const label = getEstimatedLossLabel({ max, min });

    if (label === null) {
        return null;
    }

    return <div>{label}</div>;
}
